import * as React from 'react';

const loadingStyle = {
  width: '100vw',
  height: '100vh',
  background: 'rgba(248,249,250,1)'
};

const Loading = () => <div style={loadingStyle} />;

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.tsx